/** The dashboard's time ranges. Minute buckets live 7 days, hourly 90 (S12). */

export type RangeKey = '1h' | '24h' | '7d' | '90d'

export interface RangeSpec {
  key: RangeKey
  label: string
  step: 'minute' | 'hour'
  ms: number
}

export const RANGES: readonly RangeSpec[] = [
  { key: '1h', label: 'Last hour', step: 'minute', ms: 3_600_000 },
  { key: '24h', label: 'Last 24 hours', step: 'minute', ms: 86_400_000 },
  { key: '7d', label: 'Last 7 days', step: 'hour', ms: 7 * 86_400_000 },
  { key: '90d', label: 'Last 90 days', step: 'hour', ms: 90 * 86_400_000 },
]

/**
 * The query window for a range. `now` is rounded down to the minute so the query key (and so the
 * cache entry) is stable for a minute instead of changing on every render.
 */
export function windowFor(key: RangeKey, now: number): { from: string; to: string; step: 'minute' | 'hour' } {
  const spec = RANGES.find((r) => r.key === key) ?? RANGES[0]
  if (spec === undefined) throw new Error('no ranges')
  const to = Math.floor(now / 60_000) * 60_000 + 60_000
  return { from: new Date(to - spec.ms).toISOString(), to: new Date(to).toISOString(), step: spec.step }
}
